import { defaultLang } from '@/locales/i18n';
import { defineStore, storeToRefs } from 'pinia';

const useAppStore = defineStore('app', {
  state: () => ({
    lang: '', // 语言
    expandSidebar: true, // 是否显示侧边栏
  }),

  actions: {
    /**
     * 设置多语言
     */
    setLang(lang) {
      this.lang = lang;
      document.body.className = 'lang-' + lang;
      window.localStorage.setItem('lang', lang);
    },

    // setShowSidebar(show) {
    //   this.expandSidebar = show;
    // },
  },

  getters: {
    // 获取当前语言: en、cn、kn
    curLang() {
      return this.lang || window.localStorage.getItem('lang') || defaultLang;
    },
  },
});

export default useAppStore;
